import { ErrorLbl, Input, InputLbl } from "./styles";
interface IInputLabel {
  label: string;
  placeholder: string;
  value: string;
  setValue: (value: string) => void;
  rows: number;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  readonly?: boolean;
}

export const TextAreaLabel: React.FC<IInputLabel> = ({
  label,
  placeholder,
  setValue,
  rows = 10,
  value,
  required = false,
  error = false,
  errorMessage = "Inválido.",
  readonly = false,
}) => {
  return (
    <InputLbl>
      <span className="lbl"> {label}</span>
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        required={required}
        style={{
          border: error ? "1px solid red" : "1px solid black",
          outline: "none",
        }}
        rows={rows}
        readOnly={readonly}
      />
      {error && <ErrorLbl>{errorMessage}</ErrorLbl>}
    </InputLbl>
  );
};
